<template>
  <ContentSection
    spacing="none"
    :class="conditionalSpacing"
  >
    <Container indent="lg-but-on-mobile-default">
      <!-- HEADER -->
      <h2
        v-if="data.heading"
        v-animate-in-from-bottom
        class="mb-3 typo-heading-md sm:mb-4 sm:typo-heading-lg"
        v-html="data.heading"
      />

      <figure class="aspect-video max-h-[80vh]">
        <!-- VIDEO -->
        <VideoPlayer
          v-if="data.video_url"
          :video-url="data.video_url"
          :player-params="{
            controls: 1,
            autoplay: 0,
            muted: 0,
            loop: 0,
            background: 0,
            dnt: 1, // Disable non-essential tracking cookies
          }"
          :play="true"
          :cover-image="data.cover_image"
        />

        <figcaption class="mt-2">
          <span
            v-if="data.caption"
            class="typo-body-md sm:typo-body-lg"
          >{{ data.caption }}</span>
        </figcaption>
      </figure>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { ComponentsMainVideoFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainVideoFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
)
</script>
